import {Component, Input, OnInit} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {ModalController, ToastController} from '@ionic/angular';
import {BaseClass} from '../../../../classes/base';
import {QuestionConfig} from '../../../../interfaces/process-config.interface';
import {TranslationService} from '../../../../services/translation.service';
import {UtilService} from '../../../../services/util.service';

@Component({
    selector: 'app-selection-questions',
    templateUrl: './selection-questions.component.html',
    styleUrls: ['./selection-questions.component.scss', '../../question-types.component.scss'],
})
export class SelectionQuestionsComponent extends BaseClass implements OnInit {

    @Input() question: QuestionConfig;
    @Input() formGroup: UntypedFormGroup;
    @Input() isManagerComment: boolean = false;

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _modalController: ModalController,
        private _utilService: UtilService,
    ) {
        super(_toastController, _translationService);
    }

    ngOnInit() {
    }

}
